import { trans } from "../../functions";
import { collapseFilters } from "./index/helpers";

export default {
    props: [
        "initialQuery",
        "maxPrice",
        "initialSort",
        "initialPerPage",
        "initialPage",
        "initialViewMode"
    ],

    data() {
        return {
            fetchingProducts: false,

            products: {
                data: [],
                total: 0,
                from: 0,
                to: 0,
                current_page: 1,
                last_page: 1
            },

            viewMode: this.initialViewMode || "grid",

            queryParams: {
                query: this.initialQuery || null,

                state: null,
                city: null,
                property_type: null,
                auction_status: null,

                // IMPORTANT:
                // Do not send price filters by default.
                fromPrice: null,
                toPrice: null,

                sort: this.initialSort || "latest",
                perPage: Number(this.initialPerPage) || 30,
                page: Number(this.initialPage) || 1
            }
        };
    },

    computed: {
        emptyProducts() {
            return (
                !this.products.data ||
                this.products.data.length === 0
            );
        },

        totalPage() {
            if (!this.products.total) {
                return 1;
            }

            return Math.ceil(
                this.products.total /
                    this.queryParams.perPage
            );
        },

        showingResults() {
            if (this.emptyProducts) {
                return "";
            }

            return trans(
                "storefront::products.showing_results",
                {
                    from: this.products.from,
                    to: this.products.to,
                    total: this.products.total
                }
            );
        }
    },

    mounted() {
        this.addEventListeners();
        this.fetchProducts();
    },

    methods: {
        addEventListeners() {
            if (this.$refs.sortSelect) {
                $(this.$refs.sortSelect).on(
                    "change",
                    event => {
                        this.queryParams.sort =
                            event.currentTarget.value;

                        this.queryParams.page = 1;

                        this.fetchProducts();
                    }
                );
            }

            if (this.$refs.perPageSelect) {
                $(this.$refs.perPageSelect).on(
                    "change",
                    event => {
                        this.queryParams.perPage =
                            Number(
                                event.currentTarget.value
                            );

                        this.queryParams.page = 1;

                        this.fetchProducts();
                    }
                );
            }
        },

        updatePriceRange(fromPrice, toPrice) {
            this.queryParams.fromPrice =
                fromPrice !== null &&
                fromPrice !== undefined &&
                fromPrice !== ""
                    ? fromPrice
                    : null;

            this.queryParams.toPrice =
                toPrice !== null &&
                toPrice !== undefined &&
                toPrice !== ""
                    ? toPrice
                    : null;

            this.queryParams.page = 1;

            this.fetchProducts();
        },

        changeState(value) {
            this.queryParams.state =
                value || null;

            this.queryParams.page = 1;

            this.fetchProducts();
        },

        changeCity(value) {
            this.queryParams.city =
                value || null;

            this.queryParams.page = 1;

            this.fetchProducts();
        },

        changePropertyType(value) {
            this.queryParams.property_type =
                value || null;

            this.queryParams.page = 1;

            this.fetchProducts();
        },

        changeAuctionStatus(value) {
            this.queryParams.auction_status =
                value || null;

            this.queryParams.page = 1;

            this.fetchProducts();
        },

        changePage(page) {
            this.queryParams.page = page;

            this.fetchProducts();
        },

        fetchProducts() {
            this.fetchingProducts = true;

            const params = new URLSearchParams();

            if (this.queryParams.query) {
                params.append(
                    "query",
                    this.queryParams.query
                );
            }

            if (this.queryParams.state) {
                params.append(
                    "state",
                    this.queryParams.state
                );
            }

            if (this.queryParams.city) {
                params.append(
                    "city",
                    this.queryParams.city
                );
            }

            if (this.queryParams.property_type) {
                params.append(
                    "property_type",
                    this.queryParams.property_type
                );
            }

            if (this.queryParams.auction_status) {
                params.append(
                    "auction_status",
                    this.queryParams.auction_status
                );
            }

            // Only send price filters when actually selected.
            if (
                this.queryParams.fromPrice !== null
            ) {
                params.append(
                    "fromPrice",
                    this.queryParams.fromPrice
                );
            }

            if (
                this.queryParams.toPrice !== null
            ) {
                params.append(
                    "toPrice",
                    this.queryParams.toPrice
                );
            }

            params.append(
                "sort",
                this.queryParams.sort || "latest"
            );

            params.append(
                "perPage",
                this.queryParams.perPage || 30
            );

            params.append(
                "page",
                this.queryParams.page || 1
            );

            const url =
                route("products.index") +
                "?" +
                params.toString();

            console.log(
                "Property API URL:",
                url
            );

            fetch(url, {
                method: "GET",

                headers: {
                    Accept:
                        "application/json",

                    "X-Requested-With":
                        "XMLHttpRequest"
                },

                credentials: "same-origin"
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(
                            `Property API returned ${response.status}`
                        );
                    }

                    return response.json();
                })

                .then(response => {
                    console.log(
                        "Property API Response:",
                        response
                    );

                    const properties =
                        response.properties ||
                        response.products;

                    if (
                        properties &&
                        Array.isArray(
                            properties.data
                        )
                    ) {
                        this.products =
                            properties;

                        console.log(
                            "Properties loaded:",
                            this.products
                        );
                    } else {
                        console.error(
                            "Invalid property response:",
                            response
                        );

                        this.products = {
                            data: [],
                            total: 0,
                            from: 0,
                            to: 0,
                            current_page: 1,
                            last_page: 1
                        };
                    }

                    this.$nextTick(() => {
                        collapseFilters();
                    });
                })

                .catch(error => {
                    console.error(
                        "Property API Error:",
                        error
                    );

                    this.products = {
                        data: [],
                        total: 0,
                        from: 0,
                        to: 0,
                        current_page: 1,
                        last_page: 1
                    };
                })

                .finally(() => {
                    this.fetchingProducts =
                        false;
                });
        }
    }
};